import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import * as servers from '../../../../services/api/servers';
import {GeneralServicesImplService} from '../../../../services/general-services-impl.service';
import {urls} from '../../../../services/api/urls';
import {ProjectConstants} from '../../../project-constants';

@Injectable({
  providedIn: 'root'
})
export class ConsuntivoVolumiScartoService extends GeneralServicesImplService {
  constructor(http: HttpClient) {
    super(http);
  }

  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.consuntivoVolumiScartoController;
  baseUrl: string = servers.apiUrl + urls.consuntivoVolumiScartoController;

  getPage(filters: any, payload?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE;
    const body = payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post(url, body, {headers: header, responseType: 'json', params: filters})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }


  getDownloadCsv(nameCsv: string) {
    const url = this.baseUrl + this.LINKS.DOWNLOAD_CSV + '/' + nameCsv;
    const body = null;
    const header = ProjectConstants.returnHeaderBlank();
    return this.http.get(url, {headers: header, responseType: 'text'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getNameGenerateCsv(offset, payload: any) {
    const url = this.baseUrl + this.LINKS.GENERATE_CSV;
    const body = payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post(url, body, {headers: header, responseType: 'text', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );

  }

    getNameGenerateXlsx(offset, payload: any) {
      const url = this.baseUrl + this.LINKS.GENERATE_XLSX;
      const body =  payload ? JSON.stringify(payload) : null;
      const header = ProjectConstants.returnGeneralHeader();
      return this.http.post( url, body, {headers: header, responseType: 'blob', params: offset})
        .pipe(
          // map (data => data) da inserire gestione errori
        );

    }
}
